import { storeToRefs } from 'pinia';
import { useCartStore } from '~/stores/useCartStore';

const EMPTY_SCENARIOS = {}

function parseScenarioString (raw) {
  try {
    return JSON.parse(raw) || EMPTY_SCENARIOS
  } catch (e) {
    return EMPTY_SCENARIOS
  }
}

function cloneScenarioObject (raw) {
  try {
    return JSON.parse(JSON.stringify(raw)) || EMPTY_SCENARIOS
  } catch (e) {
    return EMPTY_SCENARIOS
  }
}

function normalizeScenarios (raw) {
  if (!raw) {
    return EMPTY_SCENARIOS
  }
  if (typeof raw === 'string') {
    return parseScenarioString(raw)
  }
  return cloneScenarioObject(raw)
}

export default function useCartScenarios (appContext) {
  if (!appContext) {
    throw new Error('You must provide the nuxt app context/$pinia to use this composable');
  }
  const cartStore = useCartStore()
  const {
    cartScenarios
  } = storeToRefs(cartStore)

  const readFromLocalStorage = () => {
    return normalizeScenarios(appContext.$storage.getLocalStorage('tlmCartScenarios'))
  }

  const getGroupId = (group) => group?.groupId ?? group?.id

  const getAttrFromCartScenario = (cart, attributeName) => {
    let attributeVal = ''
    const fromStore = cartScenarios.value
    const scenarios = (fromStore && Object.keys(fromStore).length > 0)
      ? fromStore
      : readFromLocalStorage()
    cart?.cartItemGroupList?.forEach(group => {
      const groupId = getGroupId(group)
      const nextVal = scenarios?.[cart.id]?.[groupId]?.[attributeName]
      if (nextVal !== undefined && nextVal !== null && nextVal !== '') {
        attributeVal = nextVal
      }
    })
    return attributeVal
  }

  const setScenario = (updateCart, attributeName, attributeVal) => {
    if (!updateCart?.id) {
      return
    }
    const tlmCartScenarios = readFromLocalStorage()
    if (!tlmCartScenarios[updateCart.id]) {
      tlmCartScenarios[updateCart.id] = {}
    }
    updateCart?.cartItemGroupList?.forEach(group => {
      const groupId = getGroupId(group)
      if (groupId == null) {
        return
      }
      if (!tlmCartScenarios[updateCart.id][groupId]) {
        tlmCartScenarios[updateCart.id][groupId] = {}
      }
      tlmCartScenarios[updateCart.id][groupId][attributeName] = attributeVal
    })
    appContext.$storage.setLocalStorage('tlmCartScenarios', JSON.stringify(tlmCartScenarios));
    // New object reference so computed isUserInQuarantine / CartContent re-render
    cartScenarios.value = normalizeScenarios(tlmCartScenarios)
  }

  const getScenario = () => {
    cartScenarios.value = readFromLocalStorage()
    return cartScenarios
  }

  const deleteCartScenarioCookie = () => {
    appContext.$storage.removeLocalStorage('tlmCartScenarios');
    cartScenarios.value = {}
  }

  return {
    setScenario,
    getAttrFromCartScenario,
    getScenario,
    deleteCartScenarioCookie,
    cartScenarios
  }
}
